/**
 * 확정 처방 이미지 파일명 규칙.
 * 다운로드 파일명은 서버가 정하고, 여기서는 상세 화면의 개별 이미지 저장에만 쓴다.
 */

export type PrescriptionImageNameSource = {
  pharmaCompanyName?: string | null;
  clinicName?: string | null;
  businessLicenseNumber?: string | null;
  companyName?: string | null;
  userEmail?: string | null;
  prescriptionYearMonth?: string | null;
  s3FileKey?: string | null;
  imageUrl?: string | null;
  prescriptionImageUrl?: string | null;
};

/** macOS/Windows에서 파일명으로 쓸 수 없는 문자만 제거한다. */
const sanitizeFileNamePart = (value?: string | null): string =>
  String(value ?? '')
    .trim()
    .replace(/[\\/:*?"<>|]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

/** 원본 이미지 경로에서 확장자를 가져온다. 없으면 png. */
export const getPrescriptionImageExtension = (
  imagePath?: string | null,
): string => {
  const path = String(imagePath ?? '')
    .trim()
    .split(/[?#]/)[0];
  const fileName = path.split('/').pop() ?? '';
  const raw = fileName.includes('.') ? (fileName.split('.').pop() ?? '') : '';
  const extension = raw.toLowerCase().replace(/[^a-z0-9]/g, '');
  return extension || 'png';
};

const getSourceImagePath = (source: PrescriptionImageNameSource): string =>
  (
    source.imageUrl ||
    source.prescriptionImageUrl ||
    source.s3FileKey ||
    ''
  ).trim();

/**
 * 확정 처방 이미지 파일명.
 * `{처방월}_{병의원명(병의원사업자번호)}_{딜러명}_{제약회사}.{원본확장자}`
 */
export const buildPrescriptionImageFileName = (
  source: PrescriptionImageNameSource,
  options?: { withExtension?: boolean },
): string => {
  const yearMonth = sanitizeFileNamePart(source.prescriptionYearMonth);
  const clinic = sanitizeFileNamePart(source.clinicName);
  const businessLicense = sanitizeFileNamePart(source.businessLicenseNumber);
  const clinicPart = businessLicense ? `${clinic}(${businessLicense})` : clinic;
  const dealer = sanitizeFileNamePart(source.companyName);
  const pharma = sanitizeFileNamePart(source.pharmaCompanyName);
  const base = `${yearMonth}_${clinicPart}_${dealer}_${pharma}`;
  if (options?.withExtension === false) return base;
  return `${base}.${getPrescriptionImageExtension(getSourceImagePath(source))}`;
};
